module.exports = __webpack_public_path__ + "static/img/strategic-map.b51c473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/strategic-map.png
// module id = Wx6w
// module chunks = 1